import { ErrorToast } from "../components/toastify";
import { AxiosGetMethod, AxiosPostMethod } from "../helpers/customAxios";
import HandleLogout from "./handleLogout";

// ── Org: Initiate a redemption request ──────────────────────────────────────
export const initiateRedemption = async (payload) => {
  const res = await AxiosPostMethod("org/wallet/redemption/initiate", payload);
  if (res?.status === 401) HandleLogout();
  return res;
};

// ── Org: Get redemption list ─────────────────────────────────────────────────
export const getOrgRedemptionList = async (limit = 20, offset = 0) => {
  const res = await AxiosGetMethod(
    `org/wallet/redemption/list?limit=${limit}&offset=${offset}`
  );
  if (res?.status === 401) HandleLogout();
  if (res?.status === 200) return res.data.data;
  ErrorToast("Failed to fetch redemption list");
  return null;
};

// ── Org: Get single redemption detail ────────────────────────────────────────
export const getOrgRedemptionDetail = async (redemptionId) => {
  const res = await AxiosGetMethod(
    `org/wallet/redemption?redemption_id=${redemptionId}`
  );
  if (res?.status === 401) HandleLogout();
  if (res?.status === 200) return res.data.data;
  ErrorToast("Failed to fetch redemption details");
  return null;
};

// ── Admin: Get all redemptions list ──────────────────────────────────────────
export const getAdminRedemptionList = async (
  limit = 20,
  offset = 0,
  status = "",
  orgId = ""
) => {
  let query = `limit=${limit}&offset=${offset}`;
  if (status !== "") query += `&status=${status}`;
  if (orgId !== "") query += `&org_id=${orgId}`;
  const res = await AxiosGetMethod(`admin/wallet/redemption/list?${query}`);
  if (res?.status === 401) HandleLogout();
  if (res?.status === 200) return res.data.data;
  ErrorToast("Failed to fetch admin redemption list");
  return null;
};

// ── Admin: Get single redemption detail ──────────────────────────────────────
export const getAdminRedemptionDetail = async (redemptionId) => {
  const res = await AxiosGetMethod(
    `admin/wallet/redemption?redemption_id=${redemptionId}`
  );
  if (res?.status === 401) HandleLogout();
  if (res?.status === 200) return res.data.data;
  ErrorToast("Failed to fetch redemption details");
  return null;
};

// ── Admin: Approve redemption ─────────────────────────────────────────────────
export const approveRedemption = async (payload) => {
  const res = await AxiosPostMethod("admin/wallet/redemption/approve", payload);
  if (res?.status === 401) HandleLogout();
  return res;
};

// ── Admin: Reject redemption ──────────────────────────────────────────────────
export const rejectRedemption = async (payload) => {
  const res = await AxiosPostMethod("admin/wallet/redemption/reject", payload);
  if (res?.status === 401) HandleLogout();
  return res;
};
